import type { Dict } from "./types";

export const events: Dict = {
  "events.title": {
    tr: "Etkinlikler",
    en: "Events",
    de: "Events",
    fr: "Événements",
    ar: "الفعاليات",
    es: "Eventos",
  },
  "events.upcomingTitle": {
    tr: "Yaklaşan etkinlikler",
    en: "Upcoming events",
    de: "Kommende Events",
    fr: "Événements à venir",
    ar: "الفعاليات القادمة",
    es: "Próximos eventos",
  },
  "events.upcomingSubtitle": {
    tr: "JUËN üyeleri için özel etkinlikler.",
    en: "Exclusive events for JUËN members.",
    de: "Exklusive Events für JUËN-Mitglieder.",
    fr: "Événements exclusifs pour les membres JUËN.",
    ar: "فعاليات خاصة لأعضاء JUËN.",
    es: "Eventos exclusivos para socios de JUËN.",
  },
  "events.membersOnlyTitle": {
    tr: "Etkinlikler üyelere özeldir",
    en: "Events are members-only",
    de: "Events sind nur für Mitglieder",
    fr: "Les événements sont réservés aux membres",
    ar: "الفعاليات خاصة بالأعضاء",
    es: "Los eventos son solo para socios",
  },
  "events.membershipPending": {
    tr: "Üyelik başvurunuz hâlâ inceleniyor. Onaylandığında etkinliklere erişebileceksiniz.",
    en: "Your membership application is still under review. You'll be able to access events once it's approved.",
    de: "Deine Mitgliedschaftsanfrage wird noch geprüft. Sobald sie genehmigt ist, hast du Zugriff auf Events.",
    fr: "Votre demande d'adhésion est toujours en cours d'examen. Vous pourrez accéder aux événements une fois approuvée.",
    ar: "طلب عضويتك لا يزال قيد المراجعة. ستتمكن من الوصول إلى الفعاليات عند الموافقة عليه.",
    es: "Tu solicitud de membresía aún está en revisión. Podrás acceder a los eventos una vez que sea aprobada.",
  },
  "events.membershipRequired": {
    tr: "Etkinliklere erişim için onaylı üyelik gerekir.",
    en: "You need an approved membership to access events.",
    de: "Du brauchst eine bestätigte Mitgliedschaft, um auf Events zugreifen zu können.",
    fr: "Un abonnement approuvé est requis pour accéder aux événements.",
    ar: "يتطلب الوصول إلى الفعاليات عضوية معتمدة.",
    es: "Necesitas una membresía aprobada para acceder a los eventos.",
  },
  "events.noEvents": {
    tr: "Şu an yayında etkinlik yok. Yakında haberdar olacaksınız.",
    en: "No events are live right now. We'll keep you posted.",
    de: "Aktuell sind keine Events aktiv. Wir halten dich auf dem Laufenden.",
    fr: "Aucun événement en ligne pour le moment. Vous serez bientôt informé.",
    ar: "لا توجد فعاليات حاليًا. سيتم إعلامك قريبًا.",
    es: "No hay eventos en vivo en este momento. Te mantendremos informado.",
  },
  "events.detailAndTicket": {
    tr: "Detay & bilet",
    en: "Details & tickets",
    de: "Details & Tickets",
    fr: "Détails & billets",
    ar: "التفاصيل والتذاكر",
    es: "Detalles y entradas",
  },
  "events.eventTitle": {
    tr: "Etkinlik",
    en: "Event",
    de: "Event",
    fr: "Événement",
    ar: "الفعالية",
    es: "Evento",
  },
  "events.backToEvents": {
    tr: "Etkinlikler",
    en: "Events",
    de: "Events",
    fr: "Événements",
    ar: "الفعاليات",
    es: "Eventos",
  },
  "events.notFoundTitle": {
    tr: "Etkinlik bulunamadı",
    en: "Event not found",
    de: "Event nicht gefunden",
    fr: "Événement introuvable",
    ar: "لم يتم العثور على فعالية",
    es: "Evento no encontrado",
  },
  "events.backToEventsBtn": {
    tr: "Etkinliklere dön",
    en: "Back to events",
    de: "Zurück zu den Events",
    fr: "Retour aux événements",
    ar: "العودة إلى الفعاليات",
    es: "Volver a eventos",
  },
  "events.backToEvent": {
    tr: "Etkinliğe dön",
    en: "Back to event",
    de: "Zurück zum Event",
    fr: "Retour à l'événement",
    ar: "العودة إلى الفعالية",
    es: "Volver al evento",
  },
  "events.participation": {
    tr: "Katılım",
    en: "Participation",
    de: "Teilnahme",
    fr: "Participation",
    ar: "المشاركة",
    es: "Participación",
  },
  "events.tickets": {
    tr: "Biletler",
    en: "Tickets",
    de: "Tickets",
    fr: "Billets",
    ar: "التذاكر",
    es: "Entradas",
  },
  "events.drinks": {
    tr: "İçecekler",
    en: "Drinks",
    de: "Getränke",
    fr: "Boissons",
    ar: "المشروبات",
    es: "Bebidas",
  },
  "events.approvalRequired": {
    tr: "Katılmak için onaylı üyelik gerekir.",
    en: "You need an approved membership to attend.",
    de: "Um teilzunehmen, brauchst du eine bestätigte Mitgliedschaft.",
    fr: "Un abonnement approuvé est requis pour participer.",
    ar: "يتطلب الانضمام عضوية معتمدة.",
    es: "Necesitas una membresía aprobada para asistir.",
  },
  "events.ageLimitTitle": {
    tr: "Bu etkinlik +{minAge} içindir.",
    en: "This event is for +{minAge} only.",
    de: "Dieses Event ist ab {minAge} Jahren.",
    fr: "Cet événement est pour les +{minAge} ans.",
    ar: "هذه الفعالية مخصصة لعمر +{minAge}.",
    es: "Este evento es solo para mayores de +{minAge}.",
  },
  "events.ageLimitBody": {
    tr: "Yaş sınırını karşılamadığın için bu etkinliğe bilet alamazsın.",
    en: "You don't meet the age requirement, so you can't get a ticket for this event.",
    de: "Du erfüllst die Altersgrenze nicht und kannst daher kein Ticket für dieses Event erhalten.",
    fr: "Vous ne pouvez pas acheter de billet pour cet événement car vous ne remplissez pas la condition d'âge.",
    ar: "لا يمكنك شراء تذكرة لهذه الفعالية لعدم استيفاء الحد الأدنى للسن.",
    es: "No cumples con el requisito de edad, por lo que no puedes obtener una entrada para este evento.",
  },
  "events.ageLimitRule": {
    tr: "{minAge} yaş sınırı vardır.",
    en: "You must be {minAge} or older to attend.",
    de: "Du musst mindestens {minAge} Jahre alt sein, um teilzunehmen.",
    fr: "La limite d'âge est de {minAge} ans.",
    ar: "الحد الأدنى للسن هو {minAge} سنة.",
    es: "Debes tener {minAge} años o más para asistir.",
  },
  "events.inviteOnlyTitle": {
    tr: "Üyelere özel davetiye",
    en: "Members-only invitation",
    de: "Exklusive Einladung für Mitglieder",
    fr: "Invitation exclusive aux membres",
    ar: "دعوة خاصة للأعضاء",
    es: "Invitación solo para socios",
  },
  "events.inviteOnlyBody": {
    tr: "Bu etkinlik üyelere özeldir, bilet satılmaz. \"Katılmak istiyorum\" deyince hesabına 1 adet ücretsiz davetiye tanımlanır ve girişte QR kodla okutursun.",
    en: "This event is exclusive to members — no tickets are sold. Tap \"I want to join\" to get 1 free invitation added to your account, which you scan as a QR code at the door.",
    de: "Dieses Event ist exklusiv für Mitglieder — es werden keine Tickets verkauft. Tippe auf \"Ich möchte teilnehmen\", um 1 kostenlose Einladung auf deinem Konto zu erhalten, die du am Eingang als QR-Code scannst.",
    fr: "Cet événement est réservé aux membres, les billets ne sont pas vendus. En cliquant sur \"Je souhaite participer\", 1 invitation gratuite sera ajoutée à votre compte et vous la scannerez avec un code QR à l'entrée.",
    ar: "هذه الفعالية خاصة بالأعضاء، ولا تُباع التذاكر. عند النقر على \"أرغب في الانضمام\"، ستتم إضافة دعوة مجانية واحدة إلى حسابك، ويمكنك مسح رمز QR عند الدخول.",
    es: "Este evento es exclusivo para socios; no se venden entradas. Pulsa \"Quiero unirme\" para obtener 1 invitación gratuita añadida a tu cuenta, que escanearás como código QR en la entrada.",
  },
  "events.minTopupNotice": {
    tr: "Minimum harcama limiti:",
    en: "Minimum spend requirement:",
    de: "Mindestausgabe erforderlich:",
    fr: "Limite de dépense minimale :",
    ar: "الحد الأدنى للإنفاق:",
    es: "Requisito de gasto mínimo:",
  },
  "events.minTopupBody": {
    tr: "Hesabınıza girişte minimum {amount} J yükleme yapmanız gerekmektedir.",
    en: "You must top up your account with at least {amount} J at the door.",
    de: "Du musst dein Konto am Eingang mit mindestens {amount} J aufladen.",
    fr: "Vous devrez charger un minimum de {amount} J sur votre compte à l'entrée.",
    ar: "يتعين عليك شحن ما لا يقل عن {amount} J عند الدخول إلى حسابك.",
    es: "Debes recargar tu cuenta con al menos {amount} J en la entrada.",
  },
  "events.wantToJoin": {
    tr: "Katılmak istiyorum",
    en: "I want to join",
    de: "Ich möchte teilnehmen",
    fr: "Je souhaite participer",
    ar: "أرغب في الانضمام",
    es: "Quiero unirme",
  },
  "events.noTicketTypes": {
    tr: "Bu etkinlik için bilet türü tanımlı değil.",
    en: "No ticket types are defined for this event.",
    de: "Für dieses Event sind keine Tickettypen definiert.",
    fr: "Aucun type de billet défini pour cet événement.",
    ar: "لم يتم تحديد نوع تذكرة لهذه الفعالية.",
    es: "No hay tipos de entrada definidos para este evento.",
  },
  "events.free": {
    tr: "Ücretsiz",
    en: "Free",
    de: "Kostenlos",
    fr: "Gratuit",
    ar: "مجاني",
    es: "Gratis",
  },
  "events.saleComingSoon": {
    tr: "Satışı yakında",
    en: "On sale soon",
    de: "Bald erhältlich",
    fr: "Vente prochaine",
    ar: "المبيعات قريبًا",
    es: "A la venta pronto",
  },
  "events.getTicketFree": {
    tr: "Bileti al",
    en: "Get ticket",
    de: "Ticket holen",
    fr: "Acheter le billet",
    ar: "احصل على التذكرة",
    es: "Conseguir entrada",
  },
  "events.getTicket": {
    tr: "Bilet al",
    en: "Buy ticket",
    de: "Ticket kaufen",
    fr: "Acheter un billet",
    ar: "شراء تذكرة",
    es: "Comprar entrada",
  },
  "events.eventRules": {
    tr: "Etkinlik Kuralları",
    en: "Event Rules",
    de: "Veranstaltungsregeln",
    fr: "Règles de l'événement",
    ar: "قواعد الفعالية",
    es: "Normas del evento",
  },
  "events.inviteAlreadyReady": {
    tr: "Davetiyen zaten hazır",
    en: "Your invitation is already ready",
    de: "Deine Einladung ist bereits fertig",
    fr: "Votre invitation est déjà prête",
    ar: "دعوتك جاهزة بالفعل",
    es: "Tu invitación ya está lista",
  },
  "events.inviteReady": {
    tr: "Davetiyen hazır!",
    en: "Your invitation is ready!",
    de: "Deine Einladung ist fertig!",
    fr: "Votre invitation est prête !",
    ar: "دعوتك جاهزة!",
    es: "¡Tu invitación está lista!",
  },
  "events.inviteCreateFailed": {
    tr: "Davetiye oluşturulamadı",
    en: "Couldn't create invitation",
    de: "Einladung konnte nicht erstellt werden",
    fr: "Impossible de créer l'invitation",
    ar: "تعذر إنشاء الدعوة",
    es: "No se pudo crear la invitación",
  },
  "events.ageLimitToast": {
    tr: "Bu etkinlik +{minAge} içindir.",
    en: "This event is for +{minAge} only.",
    de: "Dieses Event ist ab {minAge} Jahren.",
    fr: "Cet événement est pour les +{minAge} ans.",
    ar: "هذا الحدث مخصص لمن هم فوق +{minAge}.",
    es: "Este evento es solo para mayores de +{minAge} años.",
  },
  "events.orderCreateFailed": {
    tr: "Sipariş oluşturulamadı",
    en: "Couldn't create order",
    de: "Bestellung konnte nicht erstellt werden",
    fr: "Impossible de créer la commande",
    ar: "تعذر إنشاء الطلب",
    es: "No se pudo crear el pedido",
  },
  "events.ticketCreateFailed": {
    tr: "Bilet oluşturulamadı",
    en: "Couldn't create ticket",
    de: "Ticket konnte nicht erstellt werden",
    fr: "Impossible de créer le billet",
    ar: "تعذر إنشاء التذكرة",
    es: "No se pudo crear la entrada",
  },
  "events.ticketReady": {
    tr: "Biletin hazır!",
    en: "Your ticket is ready!",
    de: "Dein Ticket ist fertig!",
    fr: "Votre billet est prêt !",
    ar: "تذكرتك جاهزة!",
    es: "¡Tu entrada está lista!",
  },
  "events.checkoutTitle": {
    tr: "Ödeme — JUËN",
    en: "Checkout — JUËN",
    de: "Bezahlung — JUËN",
    fr: "Paiement — JUËN",
    ar: "الدفع — JUËN",
    es: "Tramitar pedido — JUËN",
  },
  "events.ticketNotFoundTitle": {
    tr: "Bilet bulunamadı",
    en: "Ticket not found",
    de: "Ticket nicht gefunden",
    fr: "Billet introuvable",
    ar: "لم يتم العثور على التذكرة",
    es: "Entrada no encontrada",
  },
  "events.approvedMembershipRequired": {
    tr: "Onaylı üyelik gerekli",
    en: "Approved membership required",
    de: "Bestätigte Mitgliedschaft erforderlich",
    fr: "Adhésion approuvée requise",
    ar: "يتطلب عضوية معتمدة",
    es: "Se requiere membresía aprobada",
  },
  "events.approvedMembershipForTicket": {
    tr: "Bilet almak için üyeliğinin onaylanması gerekir.",
    en: "Your membership must be approved before you can buy tickets.",
    de: "Deine Mitgliedschaft muss bestätigt sein, bevor du Tickets kaufen kannst.",
    fr: "Votre adhésion doit être approuvée pour acheter des billets.",
    ar: "يجب الموافقة على عضويتك لشراء تذكرة.",
    es: "Tu membresía debe ser aprobada antes de que puedas comprar entradas.",
  },
  "events.ageLimitForTicket": {
    tr: "Yaş sınırını karşılamadığın için bilet alamazsın.",
    en: "You don't meet the age requirement, so you can't buy a ticket.",
    de: "Du erfüllst die Altersgrenze nicht und kannst daher kein Ticket kaufen.",
    fr: "Vous ne pouvez pas acheter de billet car vous ne remplissez pas la limite d'âge.",
    ar: "لا يمكنك شراء تذكرة لأنك لا تستوفي الحد الأدنى للسن.",
    es: "No cumples con el requisito de edad, por lo que no puedes comprar una entrada.",
  },
  "events.legalConsentRequired": {
    tr: "Devam etmek için Mesafeli Satış Sözleşmesi ve Ön Bilgilendirme Formu'nu onaylamalısın.",
    en: "You must accept the Distance Sales Agreement and Pre-Information Form to continue.",
    de: "Du musst dem Fernabsatzvertrag und dem Vorabinformationsformular zustimmen, um fortzufahren.",
    fr: "Pour continuer, vous devez approuver le Contrat de Vente à Distance et le Formulaire d'Information Préliminaire.",
    ar: "للمتابعة، يجب عليك الموافقة على عقد البيع عن بعد ونموذج المعلومات الأولية.",
    es: "Debes aceptar el Acuerdo de Venta a Distancia y el Formulario de Pre-Información para continuar.",
  },
  "events.shopierUrlMissing": {
    tr: "Bu bilet için Shopier ödeme linki tanımlı değil. Yöneticiyle iletişime geçin.",
    en: "No Shopier payment link is set up for this ticket. Please contact an admin.",
    de: "Für dieses Ticket ist kein Shopier-Zahlungslink hinterlegt. Bitte wende dich an einen Admin.",
    fr: "Aucun lien de paiement Shopier n'est défini pour ce billet. Veuillez contacter l'administrateur.",
    ar: "لا يوجد رابط دفع Shopier محدد لهذه التذكرة. يرجى التواصل مع المسؤول.",
    es: "No hay ningún enlace de pago de Shopier configurado para esta entrada. Por favor, contacta con un administrador.",
  },
  "events.paymentStep": {
    tr: "Ödeme",
    en: "Payment",
    de: "Zahlung",
    fr: "Paiement",
    ar: "الدفع",
    es: "Pago",
  },
  "events.back": {
    tr: "Geri",
    en: "Back",
    de: "Zurück",
    fr: "Retour",
    ar: "رجوع",
    es: "Atrás",
  },
  "events.ticketsInAccount": {
    tr: "Biletleriniz hesabınızda \"Biletlerim\" kısmında görünecek",
    en: "Your tickets will appear under \"My Tickets\" in your account",
    de: "Deine Tickets erscheinen in deinem Konto unter \"Meine Tickets\"",
    fr: "Vos billets apparaîtront dans \"Mes billets\" sur votre compte",
    ar: "ستظهر تذاكرك في حسابك تحت قسم \"تذاكري\"",
    es: "Tus entradas aparecerán en \"Mis entradas\" en tu cuenta",
  },
  "events.oneEvent": {
    tr: "1 Etkinlik",
    en: "1 Event",
    de: "1 Event",
    fr: "1 Événement",
    ar: "فعالية واحدة",
    es: "1 evento",
  },
  "events.ticketCount": {
    tr: "{count} bilet",
    en: "{count} ticket(s)",
    de: "{count} Ticket(s)",
    fr: "{count} billets",
    ar: "{count} تذكرة",
    es: "{count} entrada(s)",
  },
  "events.total": {
    tr: "Toplam",
    en: "Total",
    de: "Gesamt",
    fr: "Total",
    ar: "الإجمالي",
    es: "Total",
  },
  "events.subtotal": {
    tr: "Ara toplam",
    en: "Subtotal",
    de: "Zwischensumme",
    fr: "Sous-total",
    ar: "المجموع الفرعي",
    es: "Subtotal",
  },
  "events.vat": {
    tr: "KDV (%{percent})",
    en: "VAT ({percent}%)",
    de: "MwSt. ({percent}%)",
    fr: "TVA (%{percent})",
    ar: "ضريبة القيمة المضافة (%{percent})",
    es: "IVA ({percent}%)",
  },
  "events.serviceFee": {
    tr: "Hizmet bedeli",
    en: "Service fee",
    de: "Servicegebühr",
    fr: "Frais de service",
    ar: "رسوم الخدمة",
    es: "Tarifa de servicio",
  },
  "events.confirmAndPay": {
    tr: "Siparişi onayla & öde",
    en: "Confirm & pay",
    de: "Bestellung bestätigen & bezahlen",
    fr: "Confirmer & payer la commande",
    ar: "تأكيد الطلب والدفع",
    es: "Confirmar y pagar",
  },
  "events.quantity": {
    tr: "Adet",
    en: "Quantity",
    de: "Anzahl",
    fr: "Quantité",
    ar: "الكمية",
    es: "Cantidad",
  },
  "events.stockLeft": {
    tr: "Stokta {count} bilet kaldı",
    en: "{count} tickets left in stock",
    de: "Noch {count} Tickets verfügbar",
    fr: "Il reste {count} billets en stock",
    ar: "تبقى {count} تذكرة في المخزون",
    es: "Quedan {count} entradas en stock",
  },
  "events.ticketLine": {
    tr: "Bilet ({count}× {name})",
    en: "Ticket ({count}× {name})",
    de: "Ticket ({count}× {name})",
    fr: "Billet ({count}× {name})",
    ar: "تذكرة ({count}× {name})",
    es: "Entrada ({count}× {name})",
  },
  "events.proceedToPay": {
    tr: "Ödemeye geç",
    en: "Proceed to payment",
    de: "Zur Zahlung",
    fr: "Passer au paiement",
    ar: "الانتقال إلى الدفع",
    es: "Proceder al pago",
  },
  "events.securePaymentNotice": {
    tr: "Ödeme Shopier üzerinden güvenli olarak alınacaktır.",
    en: "Payment is processed securely via Shopier.",
    de: "Die Zahlung wird sicher über Shopier abgewickelt.",
    fr: "Le paiement sera effectué en toute sécurité via Shopier.",
    ar: "سيتم استلام الدفع بشكل آمن عبر Shopier.",
    es: "El pago se procesa de forma segura a través de Shopier.",
  },
  "events.drinksPageTitle": {
    tr: "İçecek Satın Al — JUËN",
    en: "Buy Drinks — JUËN",
    de: "Getränke kaufen — JUËN",
    fr: "Acheter une boisson — JUËN",
    ar: "اشترِ مشروبًا — JUËN",
    es: "Comprar bebidas — JUËN",
  },
  "events.approvedMembershipForDrinks": {
    tr: "İçecek satın almak için üyeliğinin onaylanması gerekir.",
    en: "Your membership must be approved before you can buy drinks.",
    de: "Deine Mitgliedschaft muss bestätigt sein, bevor du Getränke kaufen kannst.",
    fr: "Pour acheter une boisson, votre adhésion doit être approuvée.",
    ar: "لشراء مشروب، يجب تأكيد عضويتك.",
    es: "Tu membresía debe ser aprobada antes de que puedas comprar bebidas.",
  },
  "events.buyDrinksTitle": {
    tr: "İçecek satın al",
    en: "Buy drinks",
    de: "Getränke kaufen",
    fr: "Acheter boisson",
    ar: "شراء مشروب",
    es: "Comprar bebidas",
  },
  "events.drinkMenu": {
    tr: "İçecek menüsü",
    en: "Drink menu",
    de: "Getränkekarte",
    fr: "Menu boissons",
    ar: "قائمة المشروبات",
    es: "Menú de bebidas",
  },
  "events.noDrinkMenu": {
    tr: "Bu etkinlik için içecek menüsü tanımlı değil.",
    en: "No drink menu is defined for this event.",
    de: "Für dieses Event ist keine Getränkekarte definiert.",
    fr: "Aucun menu boisson défini pour cet événement.",
    ar: "لا توجد قائمة مشروبات محددة لهذا الحدث.",
    es: "No hay menú de bebidas definido para este evento.",
  },
  "events.totalItems": {
    tr: "Toplam ({count} adet)",
    en: "Total ({count} items)",
    de: "Gesamt ({count} Stück)",
    fr: "Total ({count} articles)",
    ar: "المجموع ({count} قطعة)",
    es: "Total ({count} artículos)",
  },
  "events.payWithJ": {
    tr: "J ile öde",
    en: "Pay with J",
    de: "Mit J bezahlen",
    fr: "Payer avec J",
    ar: "ادفع بـ J",
    es: "Pagar con J",
  },
  "events.jRequiredInfo": {
    tr: "{needed} J gerekli · Bakiyen: {balance} J",
    en: "{needed} J needed · Your balance: {balance} J",
    de: "{needed} J nötig · Dein Guthaben: {balance} J",
    fr: "{needed} J requis · Votre solde : {balance} J",
    ar: "مطلوب {needed} J · رصيدك: {balance} J",
    es: "{needed} J necesarios · Tu saldo: {balance} J",
  },
  "events.insufficient": {
    tr: "Yetersiz",
    en: "Insufficient",
    de: "Unzureichend",
    fr: "Insuffisant",
    ar: "غير كافٍ",
    es: "Insuficiente",
  },
  "events.topupHint": {
    tr: "J yüklemek için kapıdan veya bardaki kasadan işlem yapabilirsin.",
    en: "You can top up J at the door or at the bar cash desk.",
    de: "Du kannst J am Eingang oder an der Bar-Kasse aufladen.",
    fr: "Vous pouvez recharger des J à la porte ou à la caisse du bar.",
    ar: "يمكنك تحميل J من البوابة أو من الصراف في البار.",
    es: "Puedes recargar J en la entrada o en la caja de la barra.",
  },
  "events.selectAtLeastOneDrink": {
    tr: "Lütfen en az bir içecek seçin.",
    en: "Please select at least one drink.",
    de: "Bitte wähle mindestens ein Getränk aus.",
    fr: "Veuillez sélectionner au moins une boisson.",
    ar: "الرجاء اختيار مشروب واحد على الأقل.",
    es: "Por favor, selecciona al menos una bebida.",
  },
  "events.insufficientJ": {
    tr: "Yetersiz J. {needed} J gerekli, bakiyen {balance} J.",
    en: "Not enough J. {needed} J needed, your balance is {balance} J.",
    de: "Nicht genug J. {needed} J nötig, dein Guthaben ist {balance} J.",
    fr: "J insuffisants. {needed} J requis, votre solde est de {balance} J.",
    ar: "رصيد J غير كافٍ. مطلوب {needed} J، رصيدك {balance} J.",
    es: "No tienes suficientes J. Se necesitan {needed} J, tu saldo es {balance} J.",
  },
  "events.drinksOrderFailed": {
    tr: "Sipariş oluşturulamadı",
    en: "Couldn't create order",
    de: "Bestellung konnte nicht erstellt werden",
    fr: "Commande non créée",
    ar: "تعذر إنشاء الطلب",
    es: "No se pudo crear el pedido",
  },
  "events.drinksReady": {
    tr: "İçeceklerin hazır!",
    en: "Your drinks are ready!",
    de: "Deine Getränke sind fertig!",
    fr: "Vos boissons sont prêtes !",
    ar: "مشروباتك جاهزة!",
    es: "¡Tus bebidas están listas!",
  },
  "events.share": {
    tr: "Paylaş",
    en: "Share",
    de: "Teilen",
    fr: "Partager",
    ar: "مشاركة",
    es: "Compartir",
  },
  "events.shareSaveFailed": {
    tr: "Paylaşım kaydedilemedi",
    en: "Couldn't save the share",
    de: "Teilen konnte nicht gespeichert werden",
    fr: "Partage non enregistré",
    ar: "تعذر حفظ المشاركة",
    es: "No se pudo guardar la publicación",
  },
  "events.shareDownloaded": {
    tr: "Etkinlik görseli indirildi",
    en: "Event image downloaded",
    de: "Event-Bild heruntergeladen",
    fr: "Image de l'événement téléchargée",
    ar: "تم تنزيل صورة الحدث",
    es: "Imagen del evento descargada",
  },
  "events.shareImageFailed": {
    tr: "Paylaşım görseli oluşturulamadı",
    en: "Couldn't create the share image",
    de: "Teilen-Bild konnte nicht erstellt werden",
    fr: "Image de partage non générée",
    ar: "تعذر إنشاء صورة المشاركة",
    es: "No se pudo crear la imagen para compartir",
  },
};
